<template>
    <div class="row main-content" id="imageGallery">
        <div class="col-md-2">
            <sidebar>Image Gallery</sidebar>
        </div>
        <div class="col-md-10">
            <div id="img">
                <h3 style="width:100%;">CLICK ON THE IMAGE TO DOWNLOAD</h3>
                <a v-for="image in images" :href="image.img_src" download>
                    <img :src="image.img_src" :alt="image.name" />
                </a>
            </div>
            <div>
                <router-link to="/ImageGallery/">
                    <button class="btn-round-black" type="button">CHANGE PRODUCT</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [],
        }
    },
    props: ['prodId'],
    created() {
        axios.get(`/api/getImagesForProduct/${this.prodId}`).then(response => {
            this.images = response.data;
        });
    }
}
</script>
